export const GET_USER_SETTING = 'GET_USER_SETTING';
export const STORE_USER_SETTING = 'STORE_USER_SETTING';
export const SAVE_USER_SETTING = 'SAVE_USER_SETTING';

